import { yupResolver } from "@hookform/resolvers/yup"
import Box from "@mui/material/Box"
import { useMemo } from "react"
import * as yup from "yup"

import Button from "@components/button"
//import Link from "@components/link"
import TextInput from "@components/text_input"
import { emailRegex } from "@constants/validation"
import useControlledForm from "@hooks/use_controlled_form"
import useTranslate from "@hooks/use_translate"

export type LoginFormData = {
  email: string
  password: string
}

export default function LoginForm({
  onSubmit,
  loading
}: {
  onSubmit: (data: LoginFormData) => void | Promise<void>
  loading?: boolean
}) {
  const { translate } = useTranslate()

  const schema = useMemo(
    () =>
      yup
        .object({
          email: yup
            .string()
            .email(translate("email_error_invalid_email"))
            .matches(emailRegex, translate("email_error_invalid_email"))
            .required(translate("email_required")),
          password: yup
            .string()
            .min(6, translate("password_must_be_min_6_chars"))
            .required(translate("password_required"))
        })
        .required(),
    [translate]
  )

  const {
    control,
    handleSubmit,
    formState: { isValid }
  } = useControlledForm<LoginFormData>(
    {
      resolver: yupResolver(schema),
      mode: "all"
    },
    false
  )

  return (
    <Box component="form" noValidate onSubmit={handleSubmit(onSubmit)}>
      <Box pt={2}>
        <TextInput<LoginFormData>
          type="email"
          name="email"
          autoComplete="email"
          control={control}
          label={translate("email")}
          placeholder={translate("email")}
          disabled={loading}
          required
        />
        <Box sx={{ pt: 2 }}>
          <TextInput<LoginFormData>
            type="password"
            name="password"
            control={control}
            label={translate("password")}
            placeholder={translate("password")}
            autoComplete="current-password"
            disabled={loading}
            required
          />
        </Box>
      </Box>
      <Box pt={4}>
        <Button
          fullWidth
          size="large"
          type="submit"
          loading={loading}
          disabled={!isValid}
        >
          {translate("login_page_login")}
        </Button>
      </Box>
    </Box>
  )
}
